module.exports = __webpack_public_path__ + "media/images/front/sp/article/thum04-1864c52f885bfcf84c388b21def16a5e.png";